// /src/pages/admin/AdminLayout.tsx

import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import styles from "../../styles/AdminLayout.module.css";

export const AdminLayout = () => {
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = "/admin/login";
  };

  return (
    <div className={styles.adminContainer}>
      {/* Header */}
      <header className={styles.adminHeader}>
        <h1>Admin Panel</h1>
        <button onClick={handleLogout} className={styles.logoutButton}>
          Logout
        </button>
      </header>

      {/* Sidebar Navigation */}
      <nav className={styles.sidebar}>
        <ul>
          <li>
            <NavLink
              to="/admin/projects"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Manage Projects
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/artworks"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Manage Artworks
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/settings"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Edit Homepage Settings
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* Main Content Area */}
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};
